<template>
<div class="profile-page">
    <div class="col-12 team-edit-page--top">
        <div class="team-edit-page--top-wrapper">
            <svg-image
                :src="'/svg/' + resource_group + '/chevron-left.svg'"
                class="mt-0"
                :spaced="true"
                :auto_hover="true"
                @click="back()"
            >
                <div>
                    <h6 class="team-edit-page--top-name">Back</h6>
                </div>
            </svg-image>
        </div>
    </div>
    <br>

    <div class="row">
        <div class="col-xl-8 order-1 order-xl-0">
            <!--Training Certificates-->
            <certificate-card
                class="mb-3"
                v-if="training_certificates.length"
                title="Training Certificates"
                :certificates="training_certificates"
            />

            <!--Tool Certificates-->
            <certificate-card
                class="mb-3"
                v-if="tool_certificates.length"
                title="Tool Certificates"
                :certificates="tool_certificates"
            />

            <!--Face Fit Certificates-->
            <certificate-card
                class="mb-3"
                v-if="face_fit_test_certificates.length"
                title="Face Fit Test"
                :certificates="face_fit_test_certificates"
            />

            <!--PPE Equipment-->
            <ppe-equipment-card
                v-if="ppe_active"
                :ppe_registers="user.ppe_registers"
            />
        </div>

        <div class="col-xl-4 order-0 order-xl-1">
            <div class="profile-page--side-card">
                <!--Initial Briefing-->
                <div
                    v-if="initial_briefing"
                    class="profile-page--side-card-group"
                >
                    <h5 class="profile-page--side-card-group-title">Induction</h5>
                    <h6 class="profile-page--side-card-group-subtitle">Attended on
                        {{ initial_briefing.submitted_formatted_3 }}</h6>

                    <div class="profile-page--list-wrap">
                        <h6 class="profile-page--list-title">Briefing Documents</h6>
                        <list-component
                            class="profile-page--list"
                            :no_padding="true"
                            :items="job.briefing_documents"
                            action_url_prop="url"
                            no_results_message="No document uploaded"
                        />
                    </div>
                </div>

                <!--Job Documents-->
                <div class="profile-page--side-card-group mt-2">
                    <h5 class="profile-page--side-card-group-title">Job Documents</h5>

                    <div class="profile-page--list-wrap">
                        <h6 class="profile-page--list-title">RAMS</h6>
                        <list-component
                            class="profile-page--list"
                            :no_padding="true"
                            :items="job.rams_documents"
                            action_url_prop="url"
                            no_results_message="No document uploaded"
                        />
                        <h6 class="profile-page--list-title">Documents</h6>
                        <list-component
                            class="profile-page--list"
                            :no_padding="true"
                            :items="job.job_documents"
                            action_url_prop="url"
                            no_results_message="No document uploaded"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div
            id="submissions"
            class="col-12"
        >
            <collapsable
                v-for="(submissions, date, index) in submissions"
                :title="date"
                :show="index === 0"
                accordion="#submissions"
                :key="index"
            >
                <template slot="content">
                    <div
                        class="mt-2"
                        v-for="submission in submissions"
                    >
                        <h5 class="mt-1 pl-3">{{ submission.form.name }}</h5>

                        <toolbox-talks-submission
                            v-if="submission.form.type === 'toolbox_talks'"
                            :profile_page="true"
                            :form_submission="submission"
                            :name="submission.form.name"
                            :show_url="people_show_url + '?back_url=' + extra_back_url"
                        />

                        <ncr-defect-submission
                            v-else-if="submission.form.type === 'ncr_defect_notice'"
                            :profile_page="true"
                            :form_submission="submission"
                            :name="submission.form.name"
                            :show_url="people_show_url + '?back_url=' + extra_back_url"
                        />

                        <start-right-minutes-submission
                            v-else-if="submission.form.type === 'start_right_minutes'"
                            :profile_page="true"
                            :form_submission="submission"
                            :name="submission.form.name"
                            :show_url="people_show_url + '?back_url=' + extra_back_url"
                        />

                        <weekly-sheet-submission
                            v-else-if="submission.form.type === 'site_operative_register'"
                            :form_submission="submission"
                            :profile="user"
                            :job="job"
                        />
                    </div>
                </template>
            </collapsable>
        </div>
    </div>
</div>
</template>

<script>
import CertificateCard from "../people/CertificateCard";
import Collapsable from "../ListComponent/Collapsable";
import ToolboxTalksSubmission from "../submissions/ToolboxTalksSubmission";
import StartRightMinutesSubmission from "../submissions/StartRightMinutesSubmission";
import WeeklySheetSubmission from "../submissions/WeeklySheetSubmission";
import PpeEquipmentCard from "../people/PpeEquipmentCard";
import NcrDefectSubmission from "../submissions/NcrDefectSubmission";
export default {
    name: "ProfilePage",
    components: {
        NcrDefectSubmission,
        PpeEquipmentCard,
        WeeklySheetSubmission,
        StartRightMinutesSubmission, ToolboxTalksSubmission, Collapsable, CertificateCard
    },
    props: {
        user: {
            required: true
        },
        job: {
            required: true
        },
        submissions: {
            required: true
        },
        ppe_active: {
            default: false
        },
        initial_briefing: {
            default: false
        }
    },

    methods: {
        back() {
            window.history.back();
        }
    },

    computed: {
        training_certificates() {
            return this.user.certificates.filter(cert => cert.type === 'training');
        },
        tool_certificates() {
            return this.user.certificates.filter(cert => cert.type === 'tool');
        },
        face_fit_test_certificates() {
            return this.user.certificates.filter(cert => cert.type === 'face_fit_test');
        }
    }
}
</script>
